import {
  AutoCompleteMulti,
  ISelectType,
  useDebounce,
  useFetch,
} from "@4uhub/lib4uhub";
import { Grid, Typography } from "@mui/material";
import {
  ChangeEvent,
  memo,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import { internalProcedureList } from "../../../../../../../../services/internalProcedure.service";
import { useTranslation } from "react-i18next";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.automationRecRuleTicketDefDoc.";

export const DefDocInternalProcedures = memo(() => {
  const { t } = useTranslation();

  const [
    optionsTicketAutomationReceivedConfFileCaleProcedures,
    setTicketAutomationReceivedConfFileCaleProcedures,
  ] = useState<ISelectType[]>([]);

  const [
    searchByTicketAutomationReceivedConfFileCaleProcedures,
    setsearchByTicketAutomationReceivedConfFileCaleProcedures,
  ] = useState("");

  const { sendRequest: proceduresRequest } = useFetch(internalProcedureList);

  const searchQuery = useDebounce(
    searchByTicketAutomationReceivedConfFileCaleProcedures,
    500,
  );

  const paramsProcedure = useMemo(() => {
    return {
      SearchBy: searchQuery,
      EnableCode: true,
    };
  }, [searchQuery]);

  const procedureSearchBy = useCallback(
    (event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
      setsearchByTicketAutomationReceivedConfFileCaleProcedures(
        event.target.value.trim(),
      );
    },
    [],
  );

  const fetchTicketAutomationReceivedConfFileCaleProcedures =
    useCallback(async () => {
      if (paramsProcedure.SearchBy.length < 3) {
        setTicketAutomationReceivedConfFileCaleProcedures((prev) =>
          prev.length > 0 ? [] : prev,
        );
        return;
      }

      const { data, success } = await proceduresRequest(paramsProcedure);
      if (data && success) {
        setTicketAutomationReceivedConfFileCaleProcedures(
          data.map((d) => ({
            id: d.identifier.toString(),
            name: d.procedureExamName,
          })),
        );
      }
    }, [proceduresRequest, paramsProcedure]);

  useEffect(() => {
    fetchTicketAutomationReceivedConfFileCaleProcedures();
  }, [fetchTicketAutomationReceivedConfFileCaleProcedures]);

  return (
    <Grid item xs={12} sm={6}>
      <AutoCompleteMulti
        fullWidth
        value={searchByTicketAutomationReceivedConfFileCaleProcedures}
        onChange={procedureSearchBy}
        options={optionsTicketAutomationReceivedConfFileCaleProcedures}
        name="ticketAutRecRuleTicketDefDocsInternalProcedures"
        label={t(
          translationPath + "ticketAutRecRuleTicketDefDocsInternalProcedures",
        )}
        getOptionLabel={(option) => option.name}
        size="small"
        keepOpenOnSelect={true}
      />
      <Typography variant="caption" color="text.secondary" sx={{ mx: 3 }}>
        {t(translationPath + "procedure_caption")}
      </Typography>
    </Grid>
  );
});
